.head {
  max-width: 860px;
  margin-bottom: 44px;
}

.head__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  /* HACK: fluid display size — candidate future DS heading scale */
  font-size: clamp(32px, 4vw, 52px);
  line-height: 1.04;
  letter-spacing: -0.02em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 14px;
}

.head__lede {
  font-size: 18px;
  line-height: 1.5;
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 (text-2) */
  margin: 0;
}

/* Larger variant (Press): a bigger display title and an ink-colored HEADING_XS lede. */
.headLg .head__title {
  font-size: clamp(36px, 4.8vw, 64px);
  line-height: 1;
  margin-bottom: 16px;
}

.headLg .head__lede {
  font-size: 19px; /* HEADING_XS */
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}
